import React from 'react';
interface PaymentOptionsProps {
  price: number;
}
export function PaymentOptions({
  price
}: PaymentOptionsProps) {
  const paymentMethods = [{
    name: 'Al Rajhi Bank',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t7iC5vXH1SHM7rmtNcxGPm/image.png',
    description: 'Redeem Al Rajhi Bank Points'
  }, {
    name: 'Tabby',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pbKqpFRDicTn2J4rNJWWHj/image.png',
    description: `Split in 4 Payments of ${(price / 4).toFixed(2)} SAR`
  }, {
    name: 'Tamara',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kE97YFoXQ8BkWhG9HB12sB/image.png',
    description: `Split in 4 Payments of ${(price / 4).toFixed(2)} SAR`
  }, {
    name: 'Madda',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xbx3v5zuxRjxry9FzSbogq/image.png',
    description: `Split in 3 Payments of ${(price / 3).toFixed(2)} SAR`
  }];
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4921" data-mp="dsn6p1bhf4ls">
      <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-4922" data-mp="3pby186i8f9a">
        Payment Options
      </h3>
      <div className="space-y-2" data-id="element-4923" data-mp="8j7rpyfqjfyn">
        {paymentMethods.map((method, index) => <div key={index} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:border-[#1E2B55] transition-colors cursor-pointer" data-id="element-4924" data-mp="3pz63xq5we1e1" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-4925" data-mp="mipmcufppnfx">
              <img src={method.logo} alt={method.name} className="h-6 object-contain" data-id="element-4926" data-mp="rghffrs3fflp" />
              <p className="text-sm font-medium text-gray-700" data-id="element-4927" data-mp="dfy9cq76ujm6">
                {method.description}
              </p>
            </div>
            <button className="text-xs font-medium text-[#1E2B55] hover:underline whitespace-nowrap" data-id="element-4928" data-mp="hk5yuplh03lg">
              Learn More
            </button>
          </div>)}
      </div>
    </div>;
}